import React from "react";
import { Modal, Button } from "react-bootstrap";
const ConfirmationModal = ({ show, onHide, title, message, onConfirm, confirmText = "Confirm" }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title || "Confirm Action"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message || "Are you sure you want to proceed?"}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        onConfirm();
                        onHide();
                    }}
                >
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;